import { cn } from '@/lib/utils';

/**
 * 节点上「素材库 / 主体库」选择器对话框共用的视觉骨架样式。
 * AssetPickerDialog 与 SubjectPickerDialog 都基于这套样式实现，确保观感一致。
 */

/** 紧凑选择器（4×3 网格）：520px */
export const PICKER_DIALOG_CN = cn(
  'flex max-h-[90vh] w-[min(100vw-2rem,520px)] flex-col overflow-hidden p-0 gap-0 sm:w-[520px] sm:max-w-[520px]',
  'bg-sidebar/95 backdrop-blur-2xl border border-sidebar-border shadow-none rounded-2xl',
);

/** 表单弹窗（如新建/编辑主体）：720px，给参考图槽位等留出更多空间 */
export const PICKER_DIALOG_FORM_CN = cn(
  'flex max-h-[90vh] w-[min(100vw-2rem,720px)] flex-col overflow-hidden p-0 gap-0 sm:w-[720px] sm:max-w-[720px]',
  'bg-sidebar/95 backdrop-blur-2xl border border-sidebar-border shadow-none rounded-2xl',
);

/** 表单内容区：紧凑滚动 */
export const PICKER_BODY_CN =
  'custom-scrollbar min-h-0 flex-1 overflow-y-auto px-5 py-4';

export const PICKER_HEADER_CN =
  'shrink-0 px-5 pt-4 pb-3 border-b border-sidebar-border/30 bg-sidebar/40 backdrop-blur-2xl';

export const PICKER_FOOTER_CN =
  'flex shrink-0 items-center justify-between px-5 py-3 border-t border-sidebar-border/30 bg-sidebar/40';

export const PICKER_GRID_VIEWPORT_CN =
  'custom-scrollbar h-[396px] w-full shrink-0 overflow-x-hidden overflow-y-hidden p-3';

export const PICKER_GRID_CN =
  'grid h-full w-full grid-cols-4 grid-rows-3 gap-2 content-start';

export const PICKER_CARD_CN =
  'group relative min-h-0 min-w-0 rounded-xl overflow-hidden border bg-card transition-all hover:ring-2 hover:ring-primary/40 hover:border-primary/50 focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none active:scale-[0.97]';

/** 与项目筛选一致：圆角 sidebar 触发器 + 面板 */
export const PICKER_SELECT_TRIGGER_CN = cn(
  'h-9 min-w-[120px] w-[min(200px,100%)] max-w-[200px] shrink-0 rounded-xl border-none bg-sidebar-accent/50 px-3 text-xs font-medium shadow-none',
  'focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0 focus:bg-sidebar-accent transition-all',
);

export const PICKER_SELECT_CONTENT_CN =
  'border-sidebar-border bg-sidebar/95 shadow-none backdrop-blur-xl rounded-2xl p-1.5 z-[520] min-w-[var(--radix-select-trigger-width)]';

export const PICKER_SELECT_ITEM_CN =
  'rounded-lg py-2 focus:bg-primary/10 focus:text-primary cursor-pointer';

/** 私有/公开、tab 等"双段开关"按钮 */
export const PICKER_SEGMENT_GROUP_CN =
  'flex shrink-0 items-center justify-start gap-0.5 rounded-lg border border-sidebar-border/30 bg-sidebar-accent/10 p-0.5';

export const pickerSegmentItemCn = (active: boolean) =>
  cn(
    'px-2.5 py-1 text-xs font-medium rounded-md transition-all',
    active
      ? 'bg-primary text-primary-foreground shadow-sm'
      : 'text-muted-foreground hover:text-foreground hover:bg-sidebar-accent/20',
  );
